// Name of the query parameter used in the URL.
export const SHAREABLE_LINK_ID_QUERY_PARAM = "shareableLinkId";

export const UUID_REGEX =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
